// Module
var code = "<div class=\"ui-notification\"> <h3 ng-show=\"title\" ng-bind-html=\"title\"></h3> <div class=\"message\" ng-bind-html=\"message\"></div> </div> ";
// Exports
export default code;